/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders job detail instructions if none job is selected.
 */

import React from 'react';
import Image from '~/jobiqo/components/Image';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import styles from './jobSearchEmpty.module.scss';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  let imageUrl = '/static/images/job_search_empty.svg';

  return (
    <div
      style={{
        maxWidth: '60%',
        margin: 'auto',
      }}
    >
      <AlignedCenter>
        <Spacing />
        <div className={styles.imageWrapper}>
          <Image
            alt={'Empty results'}
            src={imageUrl}
            width={400}
            height={316}
          />
        </div>
      </AlignedCenter>
      <Spacing />
      <div className={styles.instructions}>
        <RichFormattedMessage
          id="job_detail_panel_instructions"
          defaultMessage="To see all the details of a job posting please choose one from the list on the left."
        />
      </div>
    </div>
  );
};
export default JobSearchEmptySlot;
